import { get, post, patch, Delete } from '@/utils/https';

export const fetchReportingData = (params) => get('/api/app/v1/reporting', params);

export const fetchReportingDashboard = (params) => get('/api/app/v1/reporting/dashboard', params);

export const fetchReportingFnp = (params) => get('/api/app/v1/reporting/fnp', params);

export const createForecastManualLine = (body) =>
  post('/api/app/v1/reporting/forecast-manual-lines', body);

export const updateForecastManualLine = (id, body, params) =>
  patch(`/api/app/v1/reporting/forecast-manual-lines/${id}?${new URLSearchParams(params || {}).toString()}`, body);

export const deleteForecastManualLine = (id, params) =>
  Delete(`/api/app/v1/reporting/forecast-manual-lines/${id}`, params);
